i18n = require '../utils/i18n.coffee'

module.exports = ->  
  riot.mixin 'i18n', new i18n()